import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component<IconMixin>({})
export default class IconMixin extends Vue {
  @Prop({ type: [Number, String], default: 24 })
  size: number | string;

  @Prop({ type: String, default: 'black' })
  color: string;
}
